<template>
  <div>
    <button @click="open = !open" class="flex items-center hover:underline">
      <span>{{ text }}</span>
      <BaseIcon name="chevron-down" :class="{ 'rotate-180': open }" size="16" />
    </button>
    <div v-if="open" class="text-sm leading-loose">
      <div class="flex my-1" v-for="event in events" :key="event.id">
        <span class="text-gray-500 w-20">{{ event.created_at | formatDay }}</span>
        <span class="mx-3">{{ event | eventText }}</span>
        <span v-if="event.done_by" class="text-gray-500">(door {{ event.done_by.name_short }})</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    account: {
      type: Object
    },
    subscription: {
      type: Object
    }
  },

  data() {
    return {
      open: false
    };
  },

  computed: {
    events() {
      let events = this.subscription.events || [];

      return [
        ...events,
        {
          id: 0,
          event: "started",
          created_at: this.account.created_at,
          done_by: this.account.created_by,
          changes: []
        }
      ];
    },

    text() {
      let licenses = this.subscription.licenses;

      let licenseEvent = this.events.filter(event => event.changes.licenses)[0];

      let msg = licenses == 1 ? "1 licentie" : licenses + " licenties";

      if (licenseEvent) {
        return `${msg}, geaccordeerd door ${licenseEvent.done_by.name}`;
      }

      return msg;
    }
  },

  filters: {
    eventText(event) {
      if (event.event === "started") return "Account aangemaakt";
      if (event.event === "created") return "Betaald account gestart";
      if (event.event === "validated") return "iDeal betaling € 0,01 ontvangen";
      if (event.changes.licenses) {
        let n = event.changes.licenses;
        let o = event.old.licenses;
        return n > o
          ? `Licenties verhoogd van ${o} naar ${n}`
          : `Licenties verlaagd van ${o} naar ${n}`;
      }
      return "Factuuradres gewijzigd";
    }
  }
};
</script>